document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('found', entry.target.classList)
        entry.target.classList.add('animate-in');
        obs.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -150px 0px',
    threshold: 0.1
  });

  document.querySelectorAll('.animate-slide-right, .animate-slide-bottom, .animate-scale-up')
    .forEach(el => observer.observe(el));

  // manual animations
  document.querySelectorAll('.home_hero_block')
    .forEach(el => observer.observe(el));
});
